window.document.addEventListener('DOMContentLoaded', () => {
    const toggleMore = document.querySelectorAll('.event-description-wrapper');

    toggleMore?.forEach((toggle) => {
        const toggleBtn = toggle.querySelector('.toggle-more');
        const toggleBtnText = toggleBtn?.querySelector('.more-text');
        const description = toggle.querySelector('.event-item-description');
        const isMultipleLines = description?.dataset.multipleLines;

        if (!toggleBtn || !description) return;
        if (description?.textContent.length >= 95 || isMultipleLines === '1') {
            toggleBtn.style.display = 'flex';
        } else {
            toggleBtn.style.display = 'none';
        }

        toggleBtn?.addEventListener('click', () => {
            toggle.classList.toggle('is-open');
            if (toggle.classList.contains('is-open')) {
                toggleBtnText.innerHTML = 'Voir moins';
            } else {
                toggleBtnText.innerHTML = 'Voir plus';
            }
        });
    });
});
